function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.505 6.689l-.006-.013-.004-.006a1.5 1.5 0 00-.56-.551l-8.25-4.64a1.509 1.509 0 00-1.47 0l-8.25 4.64a1.5 1.5 0 00-.562.554L2.4 6.68c-.003.004-.004.009-.006.013a1.498 1.498 0 00-.193.733v9.248a1.502 1.502 0 00.765 1.307l8.25 4.64c.208.117.44.182.679.19.017.002.033.003.05.003h.007a1.496 1.496 0 00.734-.193l8.25-4.64a1.502 1.502 0 00.765-1.307V7.426c0-.258-.067-.512-.195-.737zm-9.47 4.5l-7.55-4.205 7.465-4.199 7.476 4.206zm8.165 5.485l-7.489 4.212.074-8.397L20.2 8.276z",
    fill: props.fill
  }));
}

export default SvgCube;